import React, { useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { translate } from "react-multi-lang";
import { Avatar, TextField } from "@mui/material";
import { Form, Modal, Button } from "react-bootstrap";
import configuration from '../../utils/configuration';

import { formatAmount } from "./Utils";
import { sendTipWalletStart } from "../../store/actions/SendTipAction";

const defaultProfile = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg";

const SendTipModal = (props) => {
  const { walletDetails } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const modals = useSelector((state) => state.modals.general);
  const [isCancelled, setIsCancelled] = useState(false)

  const handleSendTip = (values) => {
    let data = {
      ...values,
      user_id: modals?.data?.user?.id,
    };
    if (modals?.data?.post_id) {
      data.post_id = modals?.data?.post_id;
    }
    props.dispatch(sendTipWalletStart(data));
  };

  const getTipAmountLimit = () => {
    const limit = configuration.get('configData.tip_daily_price_limit');
    return parseFloat(limit) || 0;
  };

  return (
    <>
      <Modal
        className={`modal-dialog-center verify md sent-tip-modal tip subscribemodel ${
          localStorage.getItem("isDark") === "true" ? "dark" : "light"
        }`}
        size="md"
        centered
        show={props.sendTip}
        onHide={props.closeSendTipModal}
      >
        {props.sendTip === true ? (
          <Form onSubmit={handleSubmit(handleSendTip)} translate="no">
            <Modal.Body className="p-22">
              <div className="header-userinfo">
                <div className="paymodeluinfo">
                  <div className="text-center">
                    <div className="avatarimg">
                      <Avatar
                        src={modals?.data?.user?.picture}
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "inline-block",
                        }}
                        className="avatarimg img-fluid"
                        alt='avtar'
                      >
                        <img
                          src={defaultProfile}
                          style={{ width: "80px", height: "80px" }}
                          alt="profile"
                        />
                      </Avatar>
                    </div>
                    <div className="avtarpara">
                      <h3 className="my-3">
                        <b>Tip {modals?.data?.user?.name}</b>
                      </h3>
                      <div className="w-100 d-flex justify-content-center align-items-center">
                        <div className="rounded-credit">
                          <img
                            alt="dollar icon"
                            src={
                              "https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/res_doller.svg"
                            }
                          />
                          <p className="amount-text rounded-credit-text">
                            {formatAmount(walletDetails?.remaining)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-1 mt-4">
                  <div className="form-group">
                    <TextField
                      variant="outlined"
                      fullWidth={true}
                      label={`Enter tip amount (Daily max $${getTipAmountLimit()})`}
                      placeholder={`Enter tip amount (Daily max $${getTipAmountLimit()})`}
                      error={!!errors.amount}
                      type="number"
                      helperText={errors.amount ? errors.amount.message : null}
                      {...register("amount", {
                        required: {
                          value: true,
                          message: "This amount field is required",
                        },
                        min: {
                          value: 1,
                          message: "The minimum amount allowed is $1",
                        },
                      })}
                    />
                  </div>
                  <div className="form-group mt-4">
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth={true}
                      multiline
                      maxRows={8}
                      rows={3}
                      placeholder="Enter Message"
                      error={!!errors.message}
                      helperText={
                        errors.message ? errors.message.message : null
                      }
                      {...register("message", {
                        required: {
                          value: true,
                          message: "This message field is required",
                        },
                      })}
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
            <div className="footer">
              <Button
                variant="default"
                onClick={() => {
                  setIsCancelled(true)
                  setTimeout(() =>{
                    props.closeSendTipModal()
                    setIsCancelled(false)
                  }, 10)
                }}
              >
                {!isCancelled ? 'Cancel' : 'Loading' }
              </Button>
              <Button
                disabled={props.tip.buttonDisable}
                variant="default"
                type="submit"
              >
                <div>
                  {props.tip?.loadingButtonContent
                    ? props.tip?.loadingButtonContent
                    : "Send Tip"}
                </div>
              </Button>
            </div>
          </Form>
        ) : null}
      </Modal>
    </>
  );
};

const mapStateToPros = (state) => ({
  tipStripe: state.tip.tipStripe,
  walletDetails: state.wallet.walletData?.data?.user_wallet,
  tip: state.tip.tipWallet,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(SendTipModal));
